// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Thq4","badges":"styles_badges__2dnbd"};